/** Canonical production API base for Play integrated experience (Phase 2.13C). */
export const PLAY_INTEGRATED_PRODUCTION_API_BASE = '/api/play'

/** Synchronous popup name for Dog Card navigation in integrated preview. */
export const PLAY_CONNECT_DOG_CARD_PREVIEW_WINDOW_NAME = 'wagamour-integrated-dog-card-preview'
